'use client';

import dynamic from 'next/dynamic';

export const AutoMargins = dynamic(() => import('./AutoMargins'));

export const FlexCenter = dynamic(() => import('./FlexCenter'));
export const FlexMulti = dynamic(() => import('./FlexMulti'));

export const FixedPopup = dynamic(() => import('./FixedPopup'));

export const PickTwo = dynamic(() => import('./PickTwo'));
export const GDPRPopup = dynamic(() => import('./GDPRPopup'));
export const UnknownSize = dynamic(() => import('./UnknownSize'));
export const OffCenter = dynamic(() => import('./OffCenter'));
export const GridTwoLine = dynamic(() => import('./GridTwoLine'));
export const GridVsFlexbox = dynamic(() => import('./GridVsFlexbox'));
export const GridIssueExplained = dynamic(
  () => import('./GridIssueExplained')
);
export const GridStack = dynamic(() => import('./GridStack'));
export const TextAlign = dynamic(() => import('./TextAlign'));
export const FutureAlignContent = dynamic(
  () => import('./FutureAlignContent')
);
